

const refreshToken = async (tokens, clientId) => {
  if (!tokens) {
    throw new Error('invalid tokens')
  }

  if (!clientId) {
    throw new Error('invalid clientId')
  }


  // eslint-disable-next-line no-undef
  const url = `${WEB_BFF_URL}/v1/refresh-token`
  const headers = new Headers()
  headers.append('content-type', 'application/json')

  var data = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      client_id: clientId,
      refresh_token: tokens['refresh_token'],
      access_token: tokens['access_token'],
      id_token: tokens['id_token'],
    }),
    timeout: 5000,
  }
  return await fetch(url, data)
    .then(async (res) => {
      if (res.status != 200) {
        const errorMsg = await res.json()

        const error = new Error(`[GloboID.js] API error - Status code: ${res.status} - ${errorMsg.message}`)
        error.status = res.status
        error.invalidTokenError = res.status === 400 || res.status === 401

        throw error
      }
      return res.json()
    })
    .catch((error) => { 
      if (error.message != ''){
        throw error
      }

      throw new Error('[GloboID.js] API error')
    })
}

export { refreshToken }
